import * as actionTypes from '../../actionTypes'
import { updateObject } from '../../shared/utility'

export const initialState = {
  loading: true,
  error: null,
  substackFeed: null
}

const saveSubstackFeedinitialState = {
  loading: false,
  data: null,
  error: undefined
}
// ==============================|| SUBSTACK FEED REDUCER ||============================== //

const substackFeedReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState

    case actionTypes.GETTING_SUBSTACK_FEED_SUCCESS:
      return updateObject(state, {
        loading: false,
        substackFeed: action.data,
        error: null
      })

    case actionTypes.GETTING_SUBSTACK_FEED_FAILURE:
      return updateObject(state, {
        loading: false,
        substackFeed: null,
        error: action.data
      })

    default:
      return state
  }
}

const saveSubstackFeedReducer = (state = saveSubstackFeedinitialState, action: any) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return saveSubstackFeedinitialState
    case actionTypes.SAVE_FEED_CUSTOMIZATION_REQUEST:
      return updateObject(state, {
        data: null,
        loading: true,
        error: null
      })
    case actionTypes.SAVE_FEED_CUSTOMIZATION_SUCCESS:
      return updateObject(state, {
        loading: false,
        data: action.data,
        error: null
      })
    case actionTypes.SAVE_FEED_CUSTOMIZATION_FAILURE:
      return updateObject(state, {
        loading: false,
        data: null,
        error: action.data
      })
    default:
      return state
  }
}

const getAllSubstackFeedReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState

    case actionTypes.GETTING_ALL_SUBSTACK_FEED_SUCCESS:
      return updateObject(state, {
        loading: false,
        substackFeed: action.data,
        error: null
      })

    case actionTypes.GETTING_ALL_SUBSTACK_FEED_FAILURE:
      return updateObject(state, {
        loading: false,
        substackFeed: null,
        error: action.data
      })

    default:
      return state
  }
}

export { substackFeedReducer, saveSubstackFeedReducer,getAllSubstackFeedReducer }
